import * as React from 'react';
import { useEffect, useRef } from 'react';

interface IAutoResizeTextAreaProps {
    name: string;
    value: string;

    onChange(e: React.ChangeEvent<HTMLTextAreaElement>): void;

    maxHeightPx: number;
}

const AutoResizeTextArea = ({ name, value, onChange, maxHeightPx }: IAutoResizeTextAreaProps) => {
    const textareaRef = useRef<HTMLTextAreaElement | null>(null);

    useEffect(() => {
        if (textareaRef && textareaRef.current) {
            textareaRef.current.style.height = '0px';
            let textAreaHeight = textareaRef.current.scrollHeight;

            if (textAreaHeight === 30) textAreaHeight = 50;

            if (textAreaHeight < maxHeightPx) {
                textareaRef.current.style.height = textAreaHeight + 2 + 'px';
            } else {
                textareaRef.current.style.height = maxHeightPx + 'px';
            }
        }
    }, [value, maxHeightPx]);

    return (
        <textarea
            aria-label={name}
            name={name}
            onChange={onChange}
            style={styles.textareaDefaultStyle}
            ref={textareaRef}
            value={value}
        />
    );
};

const styles: {
    [name: string]: React.CSSProperties;
} = {
    textareaDefaultStyle: {
        padding: 5,
        width: '100%',
        display: 'block',
        resize: 'none'
    }
};
export default AutoResizeTextArea;
